import script from "./ExteriorSectionJP.vue?vue&type=script&setup=true&lang=js"
export * from "./ExteriorSectionJP.vue?vue&type=script&setup=true&lang=js"

import "./ExteriorSectionJP.vue?vue&type=style&index=0&id=e85f4cdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e85f4cdc"]])

export default __exports__